import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue";
import gClaims from "@/components/g-claims/g-claims.vue";
import AccountLoged from "@/shared/mixins/AccountLoged";
import UsuarioController from "@/shared/controllers/usuario/usuarioController";
import AcessoViewModel from "@/shared/view-models/AcessoViewModel";
import AcessoController from "@/shared/controllers/acessos/AcessoController";

const name = 'GerenciamentoAcessos'
export default {
  name,

  components: { 
    gCard,
    gForm,
    gClaims,
    'g-button': gButton
  }, 

  props: { },
  mixins:[AccountLoged],

  mounted () {
    if(!this.hasClaim('Gerenciamento-Acessos')) {
      this.$router.push('/sem-acesso')
    }
    
    this.getNomeGrupo()
   },

  updated () { },

  data () {
    return {
      ClaimArray: [],
      desativaGrupo: false,
      desativaUsuario: false,
      grupoArray:[],
      UsuarioArray: [],
      acessoViewModel : new AcessoViewModel(),
      AcessoFiltroArray: [],
      arrayAcessos: [],
      claimsSelecionada: [],
      checkValidacao: false,
      arrayAll: [],
      arrayAll1: []
    }
  },

  methods: {

    getNomeGrupo() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `SistemasParametros/GetNomeGrupo`,
        data: {
          id: this.acessoViewModel.nomeGrupo
        }
      })
        .then((response) => {
          this.grupoArray = response.data.data
        })
        .catch(() => {})
    },

    getUsuario(event) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        UsuarioController.getUsuarios(event).requisicao
        .then((res => {
          this.UsuarioArray = res.data.data
        }))
      },1000);
      console.log(this.UsuarioArray)
    },

    limparFiltro() {
      this.checkValidacao = false
      this.acessoViewModel = new AcessoViewModel();
      this.desativaGrupo = false
      this.desativaUsuario = false
    },

    buscar() {
      this.pt1 = false
      this.GetAcessoByFiltro()  
    },

    GravarAcesso() {
      let acessos = this.claimsSelecionada
      acessos.forEach((ELement) => {
        ELement['UsuarioId'] = this.acessoViewModel.UsuarioId
        ELement['GrupoId'] = this.acessoViewModel.GrupoId
      })

      this.getGruposAcessos(acessos);
  },
    getGruposAcessos (objeto) {
      this.$isLoading(true)
      // if(this.acessoViewModel.UsuarioId != undefined) {
        AcessoController.postUsuarioAcesso(objeto).requisicao
        .finally(()=> {
          this.limparFiltro()
          this.$toast.add({ severity: 'success', summary: 'Aviso', detail: 'Acesso(s) atualizado(s) com sucesso!', life: 5000 });
          this.$isLoading(false)
        })
      // }
      // else {
        if(this.acessoViewModel.GrupoId != undefined) {

        AcessoController.postGrupoAcesso(objeto).requisicao
        .finally(()=> {
          this.limparFiltro()
          // this.$toast.add({ severity: 'success', summary: 'Aviso', detail: 'Acesso(s) atualizado(s) com sucesso!', life: 5000 });
          this.$isLoading(false)
        })
       }

    },
    SetClaims (data) {
      this.claimsSelecionada = data
    },
    GetAcessoByFiltro() {
      if(this.acessoViewModel.GrupoId != undefined || this.acessoViewModel.UsuarioId !=  undefined )
      {
        this.$isLoading(true)
        AcessoController.getAcessoByFiltro(this.acessoViewModel).requisicao
        .then(res => {
          this.desativaGrupo = true
          this.desativaUsuario = true

          this.ClaimArray = res.data.data || []

          this.checkValidacao = true;
                    
        })
        .finally(() => this.$isLoading(false))
      }
      else {
        this.$toast.add({severity:'error', summary: 'ERRO', detail:"É necessário selecionar ou um grupo ou um usuário!",  life: 5000})
      }
    }

   },

  computed: { }, 

};